import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ActionPlanFiltersStore } from '@/contexts/action-plans/ActionPlans.interfaces'

export const useActionPlanFiltersStore = defineStore(
  'action-plan-filters',
  () => {
    const actionPlanFilters = ref<ActionPlanFiltersStore[]>([])

    const updateActionPlanFilters = (filters: ActionPlanFiltersStore) => {
      const filterIndex = actionPlanFilters.value.findIndex(
        (storeFilter) =>
          storeFilter.actionPlanId === filters.actionPlanId && storeFilter.customerId === filters.customerId
      )

      if (filterIndex >= 0) {
        actionPlanFilters.value.splice(filterIndex, 1, filters)
      } else {
        actionPlanFilters.value.push(filters)
      }
    }

    const getActionPlanFilters = (customerId: number, actionPlanId: string): ActionPlanFiltersStore | undefined => {
      return actionPlanFilters.value.find(
        (storedFilter) => storedFilter.customerId === customerId && storedFilter.actionPlanId === actionPlanId
      )
    }

    function $reset() {
      actionPlanFilters.value = []
    }

    return { actionPlanFilters, updateActionPlanFilters, getActionPlanFilters, $reset }
  },
  { persist: true }
)
